import { action } from 'easy-peasy';

import { IActionSetActiveChannelId } from '../types';

const setActiveChannelId: IActionSetActiveChannelId = action((state, payload) => {
  state.activeChannelId = payload;
});

export default setActiveChannelId;
